$(function() {
    $('.mega, .mega-nav').on('mouseover', function() {
        $('.mega').addClass('hover');
        $('.mega-nav').show();
    });
    $('.mega, .mega-nav').on('mouseout', function() {
        $('.mega').removeClass('hover');
        $('.mega-nav').hide();
    });
    $('#hero').slick({
        slide: '.hero-slide',
        appendArrows: '.hero-arrows',
        dots: true,
        autoplay: true,
        autoplaySpeed: 8000
    });
    $('#testimonial-slider .slider').slick({
        slide: '.slide',
        appendArrows: '.controls',
        autoplay: true,
        autoplaySpeed: 8000
    });
    $('.mobile-nav').on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $('.nav').slideToggle();
    });
    $('.wish-list__add').on('click', function(e) {
        e.preventDefault();
        $this = $(this);
        $token = $('meta[name="_token"]').attr('content');
        $this.addClass('active');
        $.post('/wishlist/' + $this.data('id'), { '_token': $token });
    });
    $('.wish-list__remove').on('click', function(e) {
        e.preventDefault();
        $this = $(this);
        $token = $('meta[name=_token]').attr('content');
        $product = $this.parents('.product');
        $product.parent('div').remove();
        $wishListCount = $('.wish-list-count');
        $wishListCount.html($wishListCount.html() - 1);
        $this.removeClass('active');
        $.post('/wishlist/' + $this.data('id') + '/remove', { '_token': $token });
    });
    $('#product .thumbnails a').on('click', function(e) {
        e.preventDefault();
        $parent = $(this).parents('.thumbnails');
        $image = $(this).find('img');
        $target = $parent.find('.active img');
        $target.attr('src', $image.attr('src'));
    });
    $('.filters #sort').on('change', function() {
        $(this).parents('form').submit();
    });
    $('.per-page a').on('click', function(e) {
        e.preventDefault();
        $('#per_page').val($(this).text());
        $(this).parents('form').submit();
    });
    $('.sidebar .all a').on('click', function(e) {
        e.preventDefault();
        $self = $(this);
        $designerOverflow = $('.designer-overflow');
        if ($designerOverflow.hasClass('active')) {
            $designerOverflow.removeClass('active');
            $designerOverflow.slideUp();
            $self.text('Show All');
        } else {
            $designerOverflow.addClass('active');
            $designerOverflow.slideDown();
            $self.text('Hide');
        }
    });
    $('.product-information a').on('click', function (e) {
        e.preventDefault();
        $.scrollTo('#product-information', 750);
    });
    $('.product__sold').on('click', function (e) {
        e.preventDefault();
        $.scrollTo('#enquire-form', 750);
    });
    $('.enquiry__send').on('click', function (e) {
        e.preventDefault();
        $self = $(this);
        $self.prop('disabled', true);
        $form = $self.parents('form');
        $data = $form.serialize();
        $box = $('#enquiry__confirmation');
        $.ajax({
            url: '/contact-us',
            method: 'post',
            data: $data,
            success: function (data) {
                $.featherlight($box, {
                    closeIcon: '',
                    otherClose: '.enquiry__close'
                });
                $form.trigger('reset');
                $('.error').removeClass('error');
            },
            error: function (data) {
                $.each(data.responseJSON, function (index, elem) {
                    var input = $('*[name="'+index+'"]');
                    if (input.length > 0) {
                        input.addClass('error');
                    }
                });
            },
            complete: function () {
                $self.prop('disabled', false);
            }
        });
    });
    $('.delivery-filter').on('change', function() {
        $form = $(this).parents('form');
        $form.submit();
    });
    $('#footer select').on('change', function () {
        $val = $(this).val();
        if($val.length > 0) {
            document.location.href = '/collections/' + $val;
        }
    });
    $('.sidebar select').on('change', function () {
        document.location.href = $(this).val();
    });
    $(window).resize(function () {
        var container = $('header .nav');
        if ($(this).width() > 992 && !container.is(':visible')) {
            container.attr('style', '');
        }
    });
});
